import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { WORKFLOW } from "@/data/exceptionHub";
import { fadeUp, viewport, EASE } from "@/lib/motion";

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="relative py-24 md:py-32 bg-canvas-soft" data-testid="section-how-it-works">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal><span className="text-xs font-semibold uppercase tracking-[0.15em] text-brand">How Exception Hub Works</span></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-navy tracking-tight leading-tight text-balance">
              From detection to resolution, in one continuous flow.
            </h2>
          </Reveal>
        </div>

        <div className="relative mt-16 md:mt-20">
          <div className="absolute left-[27px] md:left-1/2 top-0 bottom-0 w-px -translate-x-1/2">
            <div className="h-full w-full bg-gradient-to-b from-transparent via-brand-connector to-transparent" />
          </div>

          <div className="space-y-8 md:space-y-0">
            {WORKFLOW.map((item, i) => {
              const left = i % 2 === 0;
              return (
                <div key={item.step} className="relative md:grid md:grid-cols-2 md:gap-16 md:py-6">
                  <motion.div initial={{ scale: 0, opacity: 0 }} whileInView={{ scale: 1, opacity: 1 }} viewport={viewport} transition={{ duration: 0.5, ease: EASE }}
                    className="absolute left-[27px] md:left-1/2 top-8 md:top-1/2 -translate-x-1/2 md:-translate-y-1/2 z-10">
                    <span className="grid place-items-center h-4 w-4 rounded-full bg-white border-2 border-brand shadow-[0_0_0_5px_rgba(37,99,235,0.08)]">
                      <span className="h-1.5 w-1.5 rounded-full bg-brand" />
                    </span>
                  </motion.div>

                  <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}
                    className={`pl-16 md:pl-0 ${left ? "md:col-start-1 md:text-right md:pr-4" : "md:col-start-2 md:pl-4"}`}>
                    <div className={`inline-block w-full rounded-2xl bg-white border border-slate-100 shadow-soft hover:shadow-card transition-shadow p-6 md:p-7 ${left ? "md:ml-auto" : ""}`}>
                      <div className={`flex items-center gap-3 ${left ? "md:justify-end" : ""}`}>
                        <span className="font-mono text-sm text-brand font-medium">{item.step}</span>
                        <h3 className="font-heading text-xl font-semibold text-navy tracking-tight">{item.title}</h3>
                      </div>
                      <p className="mt-3 text-ink-500 leading-relaxed">{item.desc}</p>
                    </div>
                  </motion.div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
